import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng';
import { Message } from '../../classes/Message';
import { ICustomerSensitivityScore } from '../../interfaces/customer-sensitivity-score';
import { CustomerSensitivityScoresService } from '../../services/customer-sensitivity-scores.service';
import { Table } from 'primeng';

@Component({
  selector: 'customer-sensitivity-scores',
  templateUrl: './customer-sensitivity-scores.component.html',
  //styleUrls: ['./customer-sensitivity-scores.component.scss'],
})
export class CustomerSensitivityScoresComponent implements OnInit {
  @ViewChild('dt') public dt: Table;

  public saving: boolean = false;

  public showEditScore: boolean = false;

  public scores: ICustomerSensitivityScore[] = [];

  public selectedScore: ICustomerSensitivityScore;

  public updateScoresDto: ICustomerSensitivityScore;

  public scoreForm: UntypedFormGroup = new UntypedFormGroup({
    shortTermScore: new UntypedFormControl(0, [Validators.min(0), Validators.max(5)]),
    longTermScore: new UntypedFormControl(0, [Validators.min(0), Validators.max(5)]),
  });

  public allowedScores = [0, 1, 2, 3, 4, 5].map((s) => ({ label: s.toString(), value: s }));

  constructor(
    private scoresService: CustomerSensitivityScoresService,
    private messageService: MessageService,
  ) {}

  getScores() {
    this.scoresService.getAllCustomerScores().then((scores) => {
      this.scores = scores;
    });
  }

  ngOnInit() {
    this.getScores();
  }

  editScore() {
    this.updateScoresDto = {
      ...this.selectedScore,
    };
    this.showEditScore = true;
  }

  async saveScore() {
    this.saving = true;
    try {
      await this.scoresService.updateCustomerScores(this.updateScoresDto);
      this.messageService.add(Message.Success('Sensitivity scores updated'));
      this.showEditScore = false;
      this.getScores();
    } catch (e) {
      this.messageService.add(Message.Error('An error occurred whilst updating scores'));
    } finally {
      this.saving = false;
    }
  }

  onSearchInput(e) {
    this.dt.filter(e.target.value, 'customerName', 'contains');
  }
}
